<div class="content-container" *ngIf="!loading">
  <div class="bordered-container">
    <h3 class="section-title">Drukwerk detail</h3>

    <div class="grid-container">
      <!-- Product Type -->
      <div class="grid-item">
        <strong>Type:</strong>
        <span>{{
          getValue(printProduction.type, printProductTypeChoices)
        }}</span>
      </div>

      <!-- Subtype -->
      <div class="grid-item" *ngIf="printProduction.subType">
        <strong>Subtype:</strong>
        <span>{{ getValue(printProduction.subType, subTypeChoices) }}</span>
      </div>

      <!-- Subtype Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="printProduction.subTypeComment"
      >
        <strong>Opmerking subtype:</strong>
        <span>{{ printProduction.subTypeComment || '-' }}</span>
      </div>

      <!-- Print Method -->
      <div class="grid-item">
        <strong>Drukwijze:</strong>
        <span>{{
          getValue(printProduction.printMethod, printMethodTypeChoices)
        }}</span>
      </div>

      <!-- Material -->
      <div class="grid-item">
        <strong>Materiaal:</strong>
        <span>{{ getValue(printProduction.material, materialOptions) }}</span>
      </div>

      <!-- Material Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="printProduction.otherMaterialComment"
      >
        <strong>Opmerking materiaal:</strong>
        <span>{{ printProduction.otherMaterialComment || '-' }}</span>
      </div>

      <!-- Number of Colors -->
      <div class="grid-item">
        <strong>Aantal kleuren:</strong>
        <span>{{
          getValue(printProduction.nbColors, nbColorsTypeChoices)
        }}</span>
      </div>

      <!-- Secondary Number of Colors -->
      <div class="grid-item" *ngIf="printProduction.secondaryNbColors">
        <strong>Kleur digitaal:</strong>
        <span>{{ NbColorsType?.CMYK }}</span>
      </div>

      <!-- Dimensions -->
      <div class="grid-item">
        <strong>Afmetingen:</strong>
        <span>{{
          getValue(printProduction.dimensions, dimensionOptions)
        }}</span>
      </div>

      <!-- Custom Dimensions -->
      <div
        class="grid-item"
        *ngIf="
          printProduction.customDimensions &&
          printProduction.customDimensions.width > 0
        "
      >
        <strong>Custom Breedte:</strong>
        <span>{{ printProduction.customDimensions?.width || '-' }}</span>
      </div>

      <div
        class="grid-item"
        *ngIf="
          printProduction.customDimensions &&
          printProduction.customDimensions.height > 0
        "
      >
        <strong>Custom Hoogte:</strong>
        <span>{{ printProduction.customDimensions?.height || '-' }}</span>
      </div>

      <!-- Dimensions Comment -->
      <div
        class="grid-item"
        style="grid-column: span 2"
        *ngIf="printProduction.dimensionsComment"
      >
        <strong>Opmerking afmeting:</strong>
        <span>{{ printProduction.dimensionsComment || '-' }}</span>
      </div>

      <!-- Film Cost -->
      <div class="grid-item" *ngIf="printProduction.filmCost">
        <strong>Filmkost:</strong>
        <span>€ {{ printProduction.filmCost || '0.00' }}</span>
      </div>

      <!-- Sieve Change -->
      <div class="grid-item" *ngIf="printProduction.sieveChange">
        <strong>Zeefwissel(st):</strong>
        <span>€ {{ printProduction.sieveChange || '0.00' }}</span>
      </div>
    </div>
  </div>

  <!-- Prices Section -->
  <div class="bordered-container">
    <h3 class="section-title">Prijzen</h3>
    <div class="price-table">
      <div class="price-table-header">
        <div class="header-cell">Aantal</div>
        <div class="header-cell">Prijs (st)</div>
        <div class="header-cell">Kapvorm (st)</div>
        <div class="header-cell">Aflopend (st)</div>
        <div class="header-cell">Reflec (st)</div>
      </div>

      <div
        class="price-table-row"
        *ngFor="let bulkPrice of printProduction.bulkPrices"
      >
        <div>{{ bulkPrice.bulkNumber }}</div>
        <div>€ {{ bulkPrice.unitPrice || '0.00' }}</div>
        <div>€ {{ bulkPrice.capShape || '0.00' }}</div>
        <div>€ {{ bulkPrice.descending || '0.00' }}</div>
        <div>€ {{ bulkPrice.reflecting || '0.00' }}</div>
      </div>
      <div
        *ngIf="
          !printProduction.bulkPrices || printProduction.bulkPrices.length == 0
        "
        class="price-table-row"
      >
        Geen prijs
      </div>
    </div>
  </div>
</div>
